import { injectable, inject } from "inversify";
import System from "../system/System";
import SERVICE_IDENTIFIER from "../constants/identifiers";
import SystemConfig, {
	CONFIG_PARAMS,
	buildHistoryUrl,
} from "../system/SystemConfig";
import BaseDOM from "../ui/BaseDOM";
import { ACTION_EVENTS } from "../ui/UserAction";
import AbstractIframePage from "./AbstractIfarmePage";
import events from "../events/EventsObservable";

@injectable()
export default class IframeHistory extends AbstractIframePage {
	protected appName: string = "history";
	constructor(
		@inject(SERVICE_IDENTIFIER.SystemConfig) config: SystemConfig,
		@inject(SERVICE_IDENTIFIER.DOM) DOM: BaseDOM,
		@inject(SERVICE_IDENTIFIER.System) system: System
		// @inject(SERVICE_IDENTIFIER.UIStates) protected states: AbstractStates
	) {
		super(config, DOM, system);
		events.subscribe(ACTION_EVENTS.ACTION_HISTORY_OPEN, (_,data) => {
			if (data && !data?.internal && data?.url) {
				this.openExternal(data.url)
			} else {
				this.open()
			}
		})
		events.subscribe(ACTION_EVENTS.ACTION_HISTORY_CLOSE, () => this.close());
	}
	create(): void {
		if (this.created) return;
		if (!this.config.get(CONFIG_PARAMS.IS_HISTORY)) return;
		super.create();

		this.iframe.setSrc(
			`${buildHistoryUrl(
				this.config.get(CONFIG_PARAMS.IS_HISTORY),
				this.config
			)}`
		);

		this.iframe.Frame.addEventListener("message", (e) => {
			console.log("HISTORY:", e);
		});
		this.iframe.setCloseAction(ACTION_EVENTS.ACTION_HISTORY_CLOSE);
	}

	open(): Promise<boolean> {
		if (
			!this.config.get(CONFIG_PARAMS.IS_HISTORY) &&
			this.config.get(CONFIG_PARAMS.URL_HISTORY_PARAM)
		) {
			location.href = this.config.get(CONFIG_PARAMS.URL_HISTORY_PARAM);
			return;
		}
		return super.open();
	}

	openExternal(url) {
		const fixed = url.startsWith('http') ? url : `https://${url}`
		window.open(fixed, '_blank')
	}

	close(): Promise<boolean> {
		// this.states.setState(STATES.IDLE)
		return super.close();
	}
}
